import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppState } from '../index';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { PickupService } from '../../data/pickup.service';
import { PickupFilterService } from '../../modules/shared/filter/pickup-filter.service';
import {
    pickupTableAddAssist,
    pickupTableChangePage, pickupTableChangeQuery,
    pickupTableFailure, pickupTableRemoveAssist,
    pickupTableRequest,
    pickupTableSort,
    pickupTableSuccess
} from './pickup-table.actions';
import { selectPickupTableQuery } from './pickup-table.state';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class PickupTableEffects {

    constructor(private actions$: Actions, private pickupService: PickupService, private store: Store<AppState>,
                private snackbar: MatSnackBar, private pickupFilterService: PickupFilterService) {
    }

    pickupTableRequest$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableRequest),
        withLatestFrom(this.store.select(selectPickupTableQuery)),
        mergeMap(([ , query ]) => this.pickupService.query(query).pipe(
            map((result) => {
                return pickupTableSuccess({
                    totalCount: result['hydra:totalItems'],
                    page: result['hydra:member']
                });
            })
        )),
        catchError((e) => of(pickupTableFailure()))
    ));

    pickupTableFailure$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`))
    ), { dispatch: false });

    pickupTableChangePage$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableChangePage),
        map(() => pickupTableRequest())
    ));

    pickupTableChangeSort$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableSort),
        map(() => pickupTableRequest())
    ));

    pickupTableChangeQuery$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableChangeQuery),
        map(() => pickupTableRequest())
    ));

    pickupTableFilterAdd$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableAddAssist),
        withLatestFrom(this.store.select(selectPickupTableQuery)),
        map(([ action, query ]) => this.pickupFilterService.applyAssist(query, action.id, action.parameter)),
        map(query => pickupTableChangeQuery({ query }))
    ));

    pickupTableFilterRemove$ = createEffect(() => this.actions$.pipe(
        ofType(pickupTableRemoveAssist),
        withLatestFrom(this.store.select(selectPickupTableQuery)),
        map(([ action, query ]) => this.pickupFilterService.removeAssist(query, action.id)),
        map(query => pickupTableChangeQuery({ query }))
    ));
}
